<template>
  <b-form-group :class="formGroupClass">
    <label><slot/></label>
    <b-form-select v-bind="$attrs"
                   :options="items"
                   :value="value"
                   :plain="true"
                   :class="addClass"
                   @input="$emit('input', $event)">
    </b-form-select>
  </b-form-group>
</template>

<script>
export default {
  name: 'SelectBox',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    value: Number,
    addClass: {
      type: Object
    },
    formGroupClass: {
      type: String,
      default: () => ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/SelectBox.vue